var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"mt-7",attrs:{"flat":"","color":"transparent"}},[_c('v-toolbar',{staticClass:"bdr secondary2light",attrs:{"elevation":0,"outlined":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('animal.reminders')))]),_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push({
                name: 'CreateTask',
                params: {
                    animal: _vm.$route.params.animal_number
                }
               })}}},[_vm._v(" Add Task ")])],1)],1),_c('v-card',{staticClass:"mt-7",attrs:{"flat":"","min-height":"600"}},[_c('v-card-text',[_c('reminders')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }